import { IonCol, IonGrid, IonRow } from '@ionic/react'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import PageWrapper from '../../components/PageWrapper/PageWrapper'
import { Button, Modal, TextLink } from 'app-principal-componentes-visuales'
import DatosUbicacion from '../../components/Cards/DatosUbicacion/DatosUbicacion'
import EliminarDomicilio from '../../components/Modals/EliminarDomicilio/EliminarDomicilio'
import { AsistenciaMedicaContext } from '../../contexts/AsistenciaMedicaContext'
import { Direccion } from '../../interfaces/direccion.interface'
import { FORMULARIO_BARRIO_CERRADO, FORMULARIO_DOMICILIO, SELECCIONAR_DOMICILIO, VERIFICAR_DATOS } from '../../utils/constants'
import { useDirecciones } from '../../hooks/useDirecciones'
import TipoFormulario from '../../components/Modals/TipoFormulario/TipoFormulario'
import './Direcciones.scss'

const Direcciones = ({ handleContinueClick, localidadError, redirectTo, propsRedirectTo, fromState }: { [key: string]: any }) => {

    const history = useHistory();
    const { useRequest, asistenciaMedica, isWeb } = useContext(AsistenciaMedicaContext);
    const [showDeleteDirectionModal, setDeleteDirectionModal] = useState(false);
    const [showTipoFormularioModal, setShowTipoFormularioModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState<Direccion>(null);
    const [selectedDirection, setSelectedDirection] = useState<Direccion>(asistenciaMedica.direccionSeleccionada);
    const socio = asistenciaMedica.socioSeleccionado;
    const direccionesSocio = asistenciaMedica?.usuario?.direcciones
    const { apiRequest } = useRequest();
    const { 
        updateDirection    
    } = useDirecciones({
        socioPrincipal: asistenciaMedica?.usuario, apiRequest, direccionesSocio, redirectTo, propsRedirectTo
    });

    const onHandleShowTipoFormularioModal = () => { 
        setShowTipoFormularioModal(true); 
    }

    useEffect(() => {
        let seleccionada = direccionesSocio.find((direccion) => direccion.seleccionado === true);
        setSelectedOption(seleccionada);
    }, [direccionesSocio, direccionesSocio.length])

    const disableButtonContinuar = localidadError || !selectedDirection || !socio.telefono || !socio.email

    /**
     * Encargado de abrir/cerrar el modal del formulario
     */
    const onHandleEditarDireccion = (selectedDirection) => {
        setSelectedDirection(selectedDirection);
        const isBarrioCerrado = selectedDirection?.barrioCerrado;
        history.push(isBarrioCerrado ? FORMULARIO_BARRIO_CERRADO : FORMULARIO_DOMICILIO, {
                selectedDirection,
                showEliminar: true
            }
        )
    }

    /**
     * Encargado de abrir/cerrar el modal de eliminacion de direcciones
     */
    const openDeleteDirection = (selectedDirection) => {
        setSelectedDirection(selectedDirection);
        setDeleteDirectionModal(!showDeleteDirectionModal);
    }

    /**
     * Metodo que elimina la direccion seleccionada del socio principal
     */
    const deleteDirection = (direccionId) => {
        let direccionSinSeleccionado = [];
        const direccionFiltrada = direccionesSocio.filter(direccion => {
            return direccionId !== direccion.id
        });

        if (direccionId === selectedOption.id && direccionFiltrada.length !== 0) {
            direccionSinSeleccionado = direccionFiltrada.map((direccion, index) => {
                if (index === direccionFiltrada.length - 1) {
                    let dirSelected = { ...direccion, seleccionado: true }
                    setSelectedOption(dirSelected);
                    return dirSelected
                }
                return direccion
            });
        }

        updateDirection(direccionSinSeleccionado.length > 0 ? direccionSinSeleccionado : direccionFiltrada);
        setDeleteDirectionModal(!showDeleteDirectionModal);
    }


    const returnSelectedDirection = (seleccionado) => {
        setSelectedOption(seleccionado);
    };

    const handleBack = () => {
        if (history?.location?.pathname === SELECCIONAR_DOMICILIO) {
            history.replace(VERIFICAR_DATOS);
        } else {
            handleContinueClick();
        }
    }

    const handleContinuarClick = () => {
        direccionSeleccionada();
        handleContinueClick(selectedOption);
    }

    const direccionSeleccionada = () => {
        let direccionAux: Direccion[] = direccionesSocio;
        direccionAux.forEach(direccion => {
            direccion.seleccionado = (direccion.id === selectedOption.id)
        });
        updateDirection(direccionAux);
    }

    return (
        <>
            {direccionesSocio.length === 0 ?
                <PageWrapper
                    pageClassName='asistencia-medica-direcciones'
                    path={SELECCIONAR_DOMICILIO}
                    socio={asistenciaMedica.usuario}
                    handlerHandleBack={handleBack}
                >
                    <IonRow>
                        <IonCol size='12' className='sin-domicilio'>
                            <Button
                                className='button--ripple'
                                colorBlack
                                label="No tenés domicilios registrados"
                            />
                        </IonCol>
                        <IonCol size='12' className='direcciones__col--padding'>
                            <TextLink
                                onClick={onHandleShowTipoFormularioModal}
                                right
                                texto="Agregar un nuevo domicilio"
                                id="nuevo-domicilio"
                            />
                        </IonCol>
                    </IonRow>
                </PageWrapper>
                :
                <PageWrapper
                    pageClassName='asistencia-medica-direcciones'
                    path={SELECCIONAR_DOMICILIO}
                    socio={asistenciaMedica.usuario}
                    handlerHandleBack={handleBack}
                    className='direcciones_container'
                    noPadding={true}
                >
                    <IonGrid>
                        <IonRow className='listado-direcciones__row'>
                            <IonCol size='12'>
                                <DatosUbicacion
                                    onEditarDireccion={onHandleEditarDireccion}
                                    direcciones={direccionesSocio}
                                    openDeleteDirection={openDeleteDirection}
                                    returnSelectedDirection = {returnSelectedDirection}
                                    setSelectedOption={setSelectedOption}
                                />
                                <TextLink
                                    className='direcciones_padding'
                                    onClick={onHandleShowTipoFormularioModal}
                                    right
                                    texto="Agregar un nuevo domicilio"
                                    id="nuevo-domicilio"
                                />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    <IonRow className={`${isWeb && "sticky-button"} direcciones_padding`} >
                        <Button
                            id="seleccionar-domicilio-continuar"
                            className='seleccionar-domicilio__button'
                            key="continue_button"
                            primary
                            onClick={handleContinuarClick}
                            label={"Continuar"}
                            disable={disableButtonContinuar}
                        />
                    </IonRow>
                </PageWrapper>
            }
            <Modal
                className='modal_web'
                //@ts-ignore
                component={
                    <TipoFormulario 
                        pathDomicilio={FORMULARIO_DOMICILIO}
                        pathBarrioCerrado={FORMULARIO_BARRIO_CERRADO}
                        propsBarrioCerrado={{propsRedirectTo, redirectTo, fromState}}
                        propsDomicilio={{propsRedirectTo, redirectTo, fromState}}
                    />
                }
                setShowModal={setShowTipoFormularioModal}
                showModal={showTipoFormularioModal}
                id="tipo-formulario-modal" 
            />
            <Modal
                className='modal_web_xl'
                hideCloseBtn
                //@ts-ignore
                component={
                    <EliminarDomicilio 
                        openDeleteDirection={openDeleteDirection} 
                        selectedDirection={selectedDirection} 
                        deleteDirection={deleteDirection} 
                        isWeb={isWeb} 
                    />
                }
                setShowModal={setDeleteDirectionModal}
                showModal={showDeleteDirectionModal}
                id="eliminar-domicilio-modal"
            />
        </>
    )
}

export default Direcciones
